export default __webpack_public_path__ + "static/media/call.85641426.png";